export const SET_PATIENT_IPDTASKS = 'SET_PATIENT_IPDTASKS';
export const SET_PATIENT_IPDTASK = 'SET_PATIENT_IPDTASK';
